<div class="row">
    <div class="col-sm-12">
      <app-card [title]="'admin.account_setting.user_information'|translate">
        <app-classic-box #classicForm  [classicBox]="classicBox" [data]="lastValue" (changeForm)="enableButton($event)"></app-classic-box>
        <div class="card-block-hid ng-trigger ng-trigger-cardToggle" style="overflow: hidden;">
          <div class="card-block pull-right">
            <button [disabled]="!enableSave"  (click)="submitItem()" class="btn btn-primary ripple light" type="button">{{'global.save_changes'|translate}}</button>
          </div>
        </div>
      </app-card>
      
      <app-modal-basic #activateTwoFactorAuthModal [dialogClass]="'modal-xl'" [hideHeader]="true" [hideFooter]="true">
        <div class="app-modal-body pt-4 px-5 d-flex flex-column justify-content-center align-items-center" *ngIf="twoFactorCodesIsLoading">
          <div class="preloader3 loader-block mx-auto">
            <div class="circ1 loader-success"></div>
            <div class="circ2 loader-success"></div>
            <div class="circ3 loader-success"></div>
          </div>
        </div>
        <div class="app-modal-body pt-4 px-5 d-flex flex-column justify-content-center align-items-center" *ngIf="!twoFactorCodesIsLoading">
          <img 
            [src]="qrCodeUrl"
            width="217" 
            height="217"
          >
          <h4 class="font-weight-bold mt-3 mb-4">
            {{(isGoogleAuthenticatorEnabled ? 'admin.backoffice.account.2fa.reactivate_title' : 'admin.backoffice.account.2fa.activate_title')|translate}}
          </h4>
          <div class="col-xl-6 col-12">
            <p class="mb-1" *ngIf="isGoogleAuthenticatorEnabled">{{'admin.backoffice.account.2fa.reactivate_description'|translate}}:</p>
            <p class="mb-1">1- {{'admin.backoffice.account.2fa.activate_item1'|translate}}</p>
            <p class="mb-1">2- {{'admin.backoffice.account.2fa.activate_item2'|translate}}</p>
            <p class="mb-1">3- {{'admin.backoffice.account.2fa.activate_item3'|translate}}</p>
          </div>
          <form #twoFactorAuth [formGroup]="twoFactorAuthForm" class="w-75">
            <formly-form  [model]="lastValueOfTwoFactorAuth" [fields]="twoFactorAuthFields"  [options]="twoFactorAuthOptions" [form]="twoFactorAuthForm">
            </formly-form>
          </form>
          <div class="d-flex justify-content-center align-items-center mb-3 mt-4">
            <button type="button" class="btn btn-simple ripple me-4" (click)="hideModal()">{{'global.cancel'|translate}}</button>
            <button 
              class="btn btn-primary ripple light" 
              type="button" 
              [disabled]="!twoFactorAuthForm.valid" 
              (click)="activateTwoFactorAuth()"
            >
              {{(isGoogleAuthenticatorEnabled ? 'global.actions.reactivate' : 'global.actions.activate')|translate}}
            </button>
          </div>
        </div>
      </app-modal-basic>

      <app-modal-basic #successfullyActivateTwoFactorModal [dialogClass]="'modal-xl'" [hideHeader]="true" [hideFooter]="true">
        <div class="app-modal-body pt-4 px-5 d-flex flex-column justify-content-center align-items-center">
          <img 
            src="../../../assets/images/user-profile/shield-check.png"
            width="160" 
            height="160"
          >
          <h4 class="font-weight-bold mt-3 mb-4">
            {{'auth.2fa.activated' |translate}}
          </h4>
          <div class="col-lg-6 col-12">
            <p class="mb-1">{{'auth.2fa.verification'|translate}}:</p>
          </div>
          <div class="d-flex justify-content-center align-items-center mb-3 mt-4">
            <button 
              class="btn btn-primary ripple light" 
              type="button" 
              (click)="closeSuccessfulTwoFactorAuth()"
            >
              {{'global.done' |translate}}
            </button>
          </div>
        </div>
      </app-modal-basic>

      <app-modal-basic #failedActivateTwoFactorModal [dialogClass]="'modal-xl'" [hideHeader]="true" [hideFooter]="true">
        <div class="app-modal-body pt-4 px-5 d-flex flex-column justify-content-center align-items-center">
          <img 
            src="../../../assets/images/user-profile/shield-exclamation.png"
            width="160" 
            height="160"
          >
          <h4 class="font-weight-bold text-danger mt-3 mb-4">
            {{'global.activation_failed' |translate}}
          </h4>
          <div class="col-lg-6 col-12">
            <p class="mb-1">{{'auth.2fa.oops'|translate}}:</p>
          </div>
          <div class="d-flex justify-content-center align-items-center mb-3 mt-4">
            <button 
              class="btn btn-primary ripple light" 
              type="button" 
              (click)="closeFailedTwoFactorAuth()"
            >
              {{'global.done' |translate}}
            </button>
          </div>
        </div>
      </app-modal-basic>
    </div>
  </div>
  